import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaChild, FaUsers } from 'react-icons/fa';

const MobileFooter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1270;

  if (!isMobile) return null;

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.includes(path);
  };

  return (
    <div className="mobile-footer">
      <div className="footer-tab-container">
      <div className="footer-tab" onClick={() => navigate('/')}>
        <FaHome className={`footer-icon ${isActive('/') ? 'active' : ''}`} />
        <span className={`footer-text ${isActive('/') ? 'active' : ''}`}>Home</span>
      </div>
      <div className="footer-tab" onClick={() => navigate('/all-kids')}>
        <FaChild className={`footer-icon ${isActive('/all-kids') ? 'active' : ''}`} />
        <span className={`footer-text ${isActive('/all-kids') ? 'active' : ''}`}>Sponsor Kids</span>
      </div>
      <div className="footer-tab" onClick={() => navigate('/sponsored-kids')}>
        <FaUsers className={`footer-icon ${isActive('/sponsored-kids') ? 'active' : ''}`} />
        <span className={`footer-text ${isActive('/sponsored-kids') ? 'active' : ''}`}>Sponsored </span>
      </div>
      </div>
      <style jsx>{`
        .mobile-footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: white;
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 10px 0;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          height: 70px;
          margin: 0;
          border-top: 1px solid #eee;
        }
        .footer-tab-container {
          display: flex;
          justify-content: space-between;
          width: 90%;
          margin: 0 auto;
          height: 100%;
        }

        .footer-tab {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          cursor: pointer;
          height: 100%;
        }

        .footer-icon {
          font-size: 24px;
          color: #999;
        }

        .footer-text {
          font-size: 12px;
          color: #999;
        }

        .footer-icon.active,
        .footer-text.active {
          color: #299d8e;
        }
      `}</style>
    </div>
  );
};

export default MobileFooter; 